import { FilesFolders } from 'constants/files-folders-enum';
import { uploadSigned } from 'helpers/aws-s3';

/**
 * Handles selfie upload for a candidate.
 *
 * @param {Object} params
 * @param {Object} params.photo - The photo Blob or Base64 data.
 * @param {Object} params.candidate - Candidate object (must include id).
 * @param {Function} params.signUpload - Function to get signed upload URL.
 * @param {Function} params.createUpload - Function to register upload in DB.
 */
export const selfieHelper = async ({ photo, candidate, signUpload, createUpload }) => {
  if (!photo || !candidate?.id) {
    throw new Error('[Selfie Upload] Missing required photo or candidate ID');
  }

  const fileName = `${candidate?.id ?? 'candidate'}_selfie.jpeg`;

  // Step 1: Get signed URL
  const signedUpload = await signUpload({
    file_name: fileName,
    file_type: 'image/jpeg',
    file_ext: 'jpeg',
    bucket_folder: FilesFolders.CandidatesApplicationDocuments,
  });

  // Step 2: Upload the selfie to S3
  await uploadSigned(signedUpload.url, photo, 'image/jpeg', true);

  // Step 3: Register the upload in backend
  const upload = await createUpload({
    candidate_id: candidate.id,
    metadata: { selfie: true },
    file_name: signedUpload.file_name,
    file_type: signedUpload.file_type,
    hash_key: signedUpload.key,
  });

  return upload;
};
